import type { Team } from "@smartsuite/automation-engine-api";
import { makeAutoObservable } from "mobx";

export class TeamsStore {
  list: Team[] = [];
  pageSize: number = 20;

  constructor() {
    makeAutoObservable(this);
  }

  setList(teams: Team[]): void {
    this.list = teams;
  }
}
